export default {
  path: 'sign',
  component: { template: '<router-view></router-view>' },
  children: [{
    path: 'index',
    name: 'jxxfJcSignIndex',
    component: () => import('./jcQdList.vue'),
    meta: { navtabTitle: '检测签到信息', isCache: true, ignoreDiff: [], menuElements: [] }
  }]
};
